var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpiral({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cyclone"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_8179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cyclone_2",
    d: "M12 16C10.9 16 9.95833 15.6083 9.175 14.825C8.39167 14.0417 8 13.1 8 12C8 10.9 8.39167 9.95833 9.175 9.175C9.95833 8.39167 10.9 8 12 8C13.1 8 14.0417 8.39167 14.825 9.175C15.6083 9.95833 16 10.9 16 12C16 13.1 15.6083 14.0417 14.825 14.825C14.0417 15.6083 13.1 16 12 16ZM12 14C12.55 14 13.0208 13.8042 13.4125 13.4125C13.8042 13.0208 14 12.55 14 12C14 11.45 13.8042 10.9792 13.4125 10.5875C13.0208 10.1958 12.55 10 12 10C11.45 10 10.9792 10.1958 10.5875 10.5875C10.1958 10.9792 10 11.45 10 12C10 12.55 10.1958 13.0208 10.5875 13.4125C10.9792 13.8042 11.45 14 12 14ZM16.525 22C16.825 21.0667 17.05 20.2333 17.2 19.5C17.35 18.7667 17.4667 18.1833 17.55 17.75C16.8333 18.45 16 19 15.05 19.4C14.1 19.8 13.0833 20 12 20C9.73333 20 7.74583 19.8458 6.0375 19.5375C4.32917 19.2292 2.98333 18.9333 2 18.65V16.525C2.93333 16.825 3.76667 17.05 4.5 17.2C5.23333 17.35 5.81667 17.4667 6.25 17.55C5.55 16.8333 5 16 4.6 15.05C4.2 14.1 4 13.0833 4 12C4 9.71667 4.15417 7.725 4.4625 6.025C4.77083 4.325 5.06667 2.98333 5.35 2H7.475C7.175 2.93333 6.94583 3.76667 6.7875 4.5C6.62917 5.23333 6.51667 5.81667 6.45 6.25C7.16667 5.55 8 5 8.95 4.6C9.9 4.2 10.9167 4 12 4C14.2833 4 16.275 4.15417 17.975 4.4625C19.675 4.77083 21.0167 5.06667 22 5.35V7.475C21.0667 7.175 20.2333 6.94583 19.5 6.7875C18.7667 6.62917 18.1833 6.51667 17.75 6.45C18.45 7.16667 19 8 19.4 8.95C19.8 9.9 20 10.9167 20 12C20 14.2833 19.8458 16.275 19.5375 17.975C19.2292 19.675 18.9333 21.0167 18.65 22H16.525ZM12 18C13.6667 18 15.0833 17.4167 16.25 16.25C17.4167 15.0833 18 13.6667 18 12C18 10.3333 17.4167 8.91667 16.25 7.75C15.0833 6.58333 13.6667 6 12 6C10.3333 6 8.91667 6.58333 7.75 7.75C6.58333 8.91667 6 10.3333 6 12C6 13.6667 6.58333 15.0833 7.75 16.25C8.91667 17.4167 10.3333 18 12 18Z",
    fill: "#1C1B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiral);
export default __webpack_public_path__ + "static/media/spiral.2de8a4e53d56f10b4b7bc41a7d0d1722.svg";
export { ForwardRef as ReactComponent };